module.exports = __webpack_public_path__ + "img/gp.bbeb52bb.png";